import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs";
import { Roles } from "../common/enums";


@Injectable()
export class AuthRoleGuard implements CanActivate {

  constructor(private readonly router: Router,
    private readonly authService: AuthService) {
  }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    let expectedRoles: string[] = route.routeConfig.data ? route.routeConfig.data.expectedRole : null;

    await this.authService.initUserGroups();

    let authorized: boolean = expectedRoles ? await this.authService.isInAnyRole(expectedRoles) : true;
    if (authorized) {

      if (route.routeConfig.path === "") {

        if (this.authService.isInRole(Roles.Planner)) {
          this.router.navigate(["/plan"])
          return true;
        }

        if (this.authService.isInRole(Roles.Dispatcher)) {
          this.router.navigate(["/dispatcher"]);
          return true;
        }

        // no access at all
        this.router.navigate(["/authorizeerror"]);
        return false;
      }

      return true;
    }

    this.router.navigate(["/authorizeerror"]);
    return false;
  }


}
